export default __webpack_public_path__ + "static/media/Boys_Glasses.1e80ff34.svg";